import React from "react";
import { Container, Row, Col } from "react-bootstrap";

const ResearchInnovation = () => {
    return (
        <section className="section research-section">
            <Container>
                <Row className="align-items-center">

                    <Col lg={6} className="fade-up">
                        <img
                            src="/images/img/research-lab.jpg"
                            alt="Research & Innovation"
                            className="img-fluid research-img"
                        />
                    </Col>

                    <Col lg={6} className="fade-up">
                        <div className="research-content">
                            <h3>Research & Innovation</h3>
                            <p>
                                At Hindustan Agro Life, innovation begins with understanding
                                real field challenges. Our R&D efforts combine scientific
                                evaluation, farmer feedback, and continuous trials.
                            </p>
                            <p>
                                We focus on creating efficient, eco-conscious formulations that
                                perform consistently across crops, climates, and soil types —
                                ensuring future-ready agricultural solutions.
                            </p>
                        </div>
                    </Col>

                </Row>
            </Container>
        </section>
    );
};

export default ResearchInnovation;
